import { commentsData } from '@/mocks/home';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block text-xs font-semibold text-primary-600 bg-primary-50 px-3 py-1 rounded-full mb-3">
            剧迷评价
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            追剧用户真实反馈
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            来自天美影视用户的真实评价，一起看看大家都在追什么好剧
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {commentsData.map((comment) => (
            <article
              key={comment.id}
              className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                </div>
                <div className="min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 truncate">
                    {comment.name}
                  </h3>
                  <p className="text-xs text-foreground-400">{comment.date}</p>
                </div>
                <div className="ml-auto flex items-center gap-0.5">
                  {Array.from({ length: 5 }).map((_, i) => (
                    <i
                      key={i}
                      className={`text-xs ${i < comment.rating ? 'ri-star-fill text-accent-400' : 'ri-star-line text-foreground-300'}`}
                    ></i>
                  ))}
                </div>
              </div>
              <div className="mb-3">
                <span className="inline-block text-xs font-medium text-primary-600 bg-primary-50 px-2 py-0.5 rounded">
                  {comment.drama}
                </span>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                {comment.content}
              </p>
              <div className="flex items-center gap-4 text-xs text-foreground-400">
                <span className="flex items-center gap-1">
                  <i className="ri-thumb-up-line"></i>
                  {comment.likes.toLocaleString()}
                </span>
                <span className="cursor-pointer hover:text-primary-500 transition-colors">
                  回复
                </span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}